import MultipleInput from "./MultipleInput";
export default MultipleInput
